var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container", attrs: { id: "goods-edit" } }, [
    _c(
      "div",
      { staticClass: "breadcrumb" },
      [
        _c(
          "el-breadcrumb",
          { attrs: { separator: "" } },
          [
            _c("el-breadcrumb-item", [
              _c("div", { staticClass: "div1" }, [_vm._v("矩阵管理")]),
            ]),
            _c("el-breadcrumb-item", [
              _c("div", { staticClass: "div2" }, [_vm._v("申请详情")]),
            ]),
          ],
          1
        ),
      ],
      1
    ),
    _vm._m(0),
    _c(
      "div",
      { staticClass: "content" },
      [
        _c("h3", [_vm._v("基本信息")]),
        _c(
          "el-form",
          {
            ref: "infoForm",
            staticClass: "info-form",
            attrs: { model: _vm.infoForm, "label-width": "130px" },
          },
          [
            _c(
              "el-form-item",
              { attrs: { label: "用户姓名" } },
              [
                _c("el-input", {
                  staticStyle: { width: "30%" },
                  attrs: { placeholder: "请输入用户姓名" },
                  model: {
                    value: _vm.infoForm.name,
                    callback: function ($$v) {
                      _vm.$set(_vm.infoForm, "name", $$v)
                    },
                    expression: "infoForm.name",
                  },
                }),
              ],
              1
            ),
            _c(
              "el-form-item",
              { attrs: { label: "联系电话" } },
              [
                _c("el-input", {
                  staticStyle: { width: "30%" },
                  attrs: {
                    placeholder: "请输入联系电话",
                    oninput:
                      "\n            value = value.replace(/[^\\d]/g, '');\n            if (value.length > 11) value = value.slice(0, 11);\n          ",
                  },
                  model: {
                    value: _vm.infoForm.phone,
                    callback: function ($$v) {
                      _vm.$set(_vm.infoForm, "phone", $$v)
                    },
                    expression: "infoForm.phone",
                  },
                }),
              ],
              1
            ),
            _c("el-form-item"),
            _c(
              "el-form-item",
              { attrs: { label: "店铺类型" } },
              [
                _c("el-input", {
                  staticStyle: { width: "30%" },
                  attrs: { placeholder: "请输入店铺类型" },
                  model: {
                    value: _vm.infoForm.type,
                    callback: function ($$v) {
                      _vm.$set(_vm.infoForm, "type", $$v)
                    },
                    expression: "infoForm.type",
                  },
                }),
              ],
              1
            ),
            _c("h3", [_vm._v("申请资料")]),
            _c(
              "el-form-item",
              { attrs: { label: "小程序名称" } },
              [
                _c("el-input", {
                  staticStyle: { width: "30%" },
                  attrs: {
                    placeholder: "请输入小程序名称",
                    maxlength: "15",
                    "show-word-limit": "",
                  },
                  model: {
                    value: _vm.infoForm.miniAppName,
                    callback: function ($$v) {
                      _vm.$set(_vm.infoForm, "miniAppName", $$v)
                    },
                    expression: "infoForm.miniAppName",
                  },
                }),
              ],
              1
            ),
            _c(
              "el-form-item",
              { attrs: { label: "小程序说明" } },
              [
                _c("el-input", {
                  staticStyle: { width: "30%" },
                  attrs: {
                    type: "textarea",
                    placeholder: "请输入小程序说明",
                    maxlength: "120",
                    "show-word-limit": "",
                    rows: 5,
                  },
                  model: {
                    value: _vm.infoForm.miniAppInfo,
                    callback: function ($$v) {
                      _vm.$set(_vm.infoForm, "miniAppInfo", $$v)
                    },
                    expression: "infoForm.miniAppInfo",
                  },
                }),
              ],
              1
            ),
            _c(
              "el-form-item",
              { attrs: { label: "小程序头像" } },
              [
                _c("headerPicture", {
                  attrs: { qrCodeUrl: _vm.infoForm.miniAppTopImg },
                  on: {
                    getUrl: function ($event) {
                      return _vm.getImage($event)
                    },
                  },
                }),
              ],
              1
            ),
            _c("el-form-item", { attrs: { label: "小程序管理员电话" } }, [
              _c(
                "div",
                [
                  _c("el-input", {
                    staticStyle: { width: "30%" },
                    attrs: {
                      placeholder: "请输入电话",
                      oninput:
                        "\n            value = value.replace(/[^\\d]/g, '');\n            if (value.length > 11) value = value.slice(0, 11);\n          ",
                    },
                    model: {
                      value: _vm.infoForm.miniAppManagerPhone,
                      callback: function ($$v) {
                        _vm.$set(_vm.infoForm, "miniAppManagerPhone", $$v)
                      },
                      expression: "infoForm.miniAppManagerPhone",
                    },
                  }),
                ],
                1
              ),
            ]),
            _c(
              "el-form-item",
              { attrs: { label: "管理员身份证正面" } },
              [
                _c("upload-means", {
                  attrs: {
                    type: "1",
                    managerIdentifyTop: _vm.infoForm.managerIdentifyTop,
                  },
                  on: {
                    getUrl: function ($event) {
                      return _vm.getUrl($event, "1")
                    },
                  },
                }),
              ],
              1
            ),
            _c(
              "el-form-item",
              { attrs: { label: "管理员身份证反面", prop: "name" } },
              [
                _c("upload-means", {
                  attrs: {
                    type: "2",
                    managerIdentifyBottom: _vm.infoForm.managerIdentifyBottom,
                  },
                  on: {
                    getUrl: function ($event) {
                      return _vm.getUrl($event, "2")
                    },
                  },
                }),
              ],
              1
            ),
            _c(
              "el-form-item",
              { attrs: { label: "营业执照", prop: "name" } },
              [
                _c("upload-means", {
                  attrs: { type: "0", license: _vm.infoForm.license },
                  on: {
                    getUrl: function ($event) {
                      return _vm.getUrl($event, "")
                    },
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          {
            staticStyle: {
              width: "30%",
              "text-align": "center",
              "padding-bottom": "20px",
            },
          },
          [
            _c(
              "el-button",
              {
                attrs: { type: "primary" },
                on: {
                  click: function ($event) {
                    return _vm.submit()
                  },
                },
              },
              [_vm._v("确认")]
            ),
            _c("el-button", { on: { click: _vm.back } }, [_vm._v("返回")]),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "content page-title" }, [
      _c("h2", [_vm._v("申请详情")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }